/* assets/br-story-hero.js — hero and story-banner films: registers with GlobalVideoController; holds on poster for reduced motion */
(function () {
  'use strict';

  function setButtonState(btn, isPaused) {
    if (!btn) return;
    btn.setAttribute('aria-pressed', isPaused ? 'true' : 'false');
    // Keep whatever the label already says after the verb, so the film's own
    // name survives the swap.
    const current = btn.getAttribute('aria-label') || '';
    const rest = current.replace(/^(Pause|Play) video:\s*/i, '');
    const label = (isPaused ? 'Play video: ' : 'Pause video: ') + rest;
    btn.setAttribute('aria-label', label);
    const sr = btn.querySelector('.sr-only');
    if (sr) sr.textContent = label;
  }

  function init() {
    document.querySelectorAll('.br-story-hero__card, .br-story-banner').forEach(card => {
      const video = card.querySelector('[data-hero-video]');
      const btn = card.querySelector('[data-video-pause-btn]');
      if (!video) return;

      const reduce = window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (window.GlobalVideoController) {
        window.GlobalVideoController.register(video);
      }

      if (reduce) {
        // Never start on its own for a reader who has asked for stillness.
        video.removeAttribute('autoplay');
        // Go through the controller so [data-videos-paused] on <html> matches
        // reality - the button's icon reads from that, not from this element.
        if (window.GlobalVideoController) {
          window.GlobalVideoController.pauseAll();
        } else {
          video.pause();
          setButtonState(btn, true);
        }
      } else if (window.GlobalVideoController && window.GlobalVideoController.isPaused) {
        video.pause();
        setButtonState(btn, true);
      }

      video.addEventListener('play', () => setButtonState(btn, false));
      video.addEventListener('pause', () => setButtonState(btn, true));

      // With no controller present the button still has to work.
      if (btn && !window.GlobalVideoController) {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          video.paused ? video.play().catch(() => {}) : video.pause();
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
